(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
